import {
	ShFileFilter,
	StoreArchiveInput,
	StoreFilesInput,
	TextFile
} from '@shure/shared/electron/features/file-system/models';

import { BasicFileHandlerService } from './basic-file-handler-service';

export interface FileHandlerServiceConfig {
	title: string;
	fileExtensions: ShFileFilter[];
}

export interface FileHandlerResponse {
	canceled: boolean;
	path?: string;
	paths?: string[];
}

export abstract class FileHandlerService extends BasicFileHandlerService {
	public abstract handleOpenFolder(title: string): Promise<FileHandlerResponse>;
	public abstract handleGetFileSize(filePath?: string): Promise<number>;
	public abstract handleLoadBinaryFile(filePath?: string): Promise<File>;
	public abstract handleLoadBinaryFileToBase64String(filePath?: string): Promise<string>;
	public abstract handleCreateTempFolder(): Promise<string>;
	public abstract handleRemoveFolderOrFile(fullPath: string): Promise<void>;
	public abstract handleStoreFiles(input: StoreFilesInput): Promise<string[]>;
	public abstract handleReadFile(filePath: string): Promise<TextFile>;
	public abstract handleReadLogFile(): Promise<Uint8Array>;
	public abstract handleLoadArchive(fullPath: string): Promise<Map<string, string>>;
	public abstract handleStoreArchive(input: StoreArchiveInput): Promise<void>;
}
